import React from 'react';
import get from 'lodash/get';

export const sumByField = (array, {
  groupByField,
  countField,
  sumFields,
  groupMembersField,
}) => Object.values(array
  .reduce((all, row) => ({
    ...all,
    [row[groupByField]]: {
      ...row,
      ...Object.fromEntries(
        sumFields.map(
          name => [name, (get(all, [row[groupByField], name]) || 0) + row[name]]
        )
      ),
      [countField]: (get(all, [row[groupByField], countField]) || 0) + 1,
      [groupMembersField]: [
        ...(get(all, [row[groupByField], groupMembersField]) || []),
        row
      ]
    } 
  }), {}));

export const getSummaryRow = array =>
  array.reduce((all, row) => Object.fromEntries(
    Object.entries(row)
      .map(([key, value]) => [key, typeof(value) === 'number' ? (all[key] || 0) + value : undefined])
  ), {});

export const stageLookup = {
  INTERIM: 'Interim Forecast',
  INITIAL: 'Initial Update',
  FINAL: 'Final Report',
};
